module.exports = __webpack_public_path__ + "static/wings-9dcd0784533aa4672de470473799553a.png";